import { RyderEnvironment } from "@redotech/redo-integrations-definitions-common/integration/ryder/types";
import * as z from "zod";

export const updateRyderIntegration = {
  name: "updateRyderIntegration" as const,
  input: z.object({
    environment: z.nativeEnum(RyderEnvironment),
    createReturnsEnabled: z.boolean(),
    processReturnsEnabled: z.boolean(),
    forceBlindReturns: z.boolean(),
    allowBlindReturnsFallback: z.boolean(),
  }),
  output: z.object({}),
};
